import './CheckBox.scss';
import Control from "../../Control";
import NP, {EventArgs} from "../../NP";
import Delegate from "../../Delegate";


export default class CheckBox extends Control {
	private _Checked: boolean;
	public EvCheckedChanged: Delegate;
	private _cbxNode: HTMLElement;
	private _cntNode: HTMLElement;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._Checked = false;
		this.EvCheckedChanged = new Delegate();
		super._initFields(settings);
	}

	getChecked()
	{
		return this._Checked;
	}

	_render()
	{
		this._componentInit();
		this._cbxNode = this._root.querySelector('.icon');
		this._cntNode = this._root.querySelector('.content');
		this._setContentToNode(this._Content, this._cntNode, "Content", true);
		if (this._Content)
			NP.showNode(this._cntNode);
		else
			NP.hideNode(this._cntNode);

		this.setChecked(this._Checked, false, true);

		super._render();

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	_componentInit(){
		this._initComponent("<div class='checkbox font_subheading'>" +
			 "<span class='icon'>" +
			 "<span class='ic_check_box_outline checkboxoff check-box-ic'></span>" +
			 "<span class='ic_check_box checkboxon check-box-ic'></span>" +
			 "</span>" +
			 "<span class='content'></span>" +
			 "</div>");

	}

	_onClicked(sender: Control, args: EventArgs)
	{
		if (this._Enabled)
			this.setChecked(!this._Checked);
		return super._onClicked(sender, args);
	}

	_onMouseDown(sender: Control, args: EventArgs)
	{
		if (this._Enabled)
			this.addClass('checkbox-active');
		return super._onMouseDown(sender, args);
	}


	setChecked(value: boolean, fireEvent?: boolean, _reInit?: boolean)
	{
		if (value != this._Checked || _reInit)
		{
			var oldValue = this._Checked;
			this._Checked = value;
			if (value)
				this.addClass('checkbox-checked');
			else
				this.removeClass('checkbox-checked');
			if (fireEvent !== false)
			{
				this.EvCheckedChanged.fire(this, {
					OldValue: oldValue,
					Value: value
				});
			}
		}
	}

	getValue()
	{
		return this._Checked;
	}

	setValue(value: boolean, fireEvent?: boolean)
	{
		this.setChecked(value, fireEvent);
	}

	setContent(value: string)
	{
		this._setContentToNode(value, this._cntNode);
		if (this._Content)
			NP.showNode(this._cntNode);
		else
			NP.hideNode(this._cntNode);
	}

};

NP.CheckBox = CheckBox;